/**
 * debugStep — emisor de eventos `debug:step` para el DebugDrawer.
 *
 * Patrón de uso:
 *   const finish = debugStep('loadTableSchema', { tableName });
 *   const schema = await fetchSchema();
 *   finish({ columnCount: schema.length });
 *
 * El drawer (visible solo a superadmins) escucha `window.addEventListener('debug:step', ...)`.
 * Si el drawer no está montado, los events siguen disparándose pero nadie los recibe:
 * el costo es trivial (CustomEvent + dispatchEvent + performance.now()).
 *
 * Cero overhead funcional para usuarios no-superadmin.
 */
export function debugStep(label: string, meta?: Record<string, unknown>) {
  const t0 = performance.now();
  try {
    window.dispatchEvent(
      new CustomEvent('debug:step', {
        detail: { label, phase: 'start', meta },
      })
    );
  } catch {
    // SSR / entornos sin window: no-op
  }

  return (endMeta?: Record<string, unknown>) => {
    try {
      window.dispatchEvent(
        new CustomEvent('debug:step', {
          detail: {
            label,
            phase: 'end',
            durationMs: performance.now() - t0,
            meta: { ...(meta || {}), ...(endMeta || {}) },
          },
        })
      );
    } catch {
      // ignore
    }
  };
}
